// extracted by mini-css-extract-plugin
module.exports = {"news":"news_news__3zyMZ","infoblock":"news_infoblock__2o0cJ"};